<template>
    <div
			id="keyboard"
			class="keyboard-wrapper"
			:class="{ 'external': !showByDefault }"
			:style="externalKeyboardStyle"
		>
	    <div class="container" v-if="show && !osKeyboardVisible" v-click-outside="blur">
		    <div class="cross" v-if="hasCloseBtn">
				<icon-component iconName="close" class="close" @click="closeKeyboard" />
			</div>
		    <div class="keyboard">
			    <div class="row first-row">
				    <button @click="handleOnButtonClick('q', '1', false)" class="letter ">{{handleOnButtonText('q', 1)}}</button>
				    <button @click="handleOnButtonClick('w', '2', false)" class="letter ">{{handleOnButtonText('w', 2)}}</button>
				    <button @click="handleOnButtonClick('e', '3', false)" class="letter ">{{handleOnButtonText('e', 3)}}</button>
				    <button @click="handleOnButtonClick('r', '4', false)" class="letter ">{{handleOnButtonText('r', 4)}}</button>
				    <button @click="handleOnButtonClick('t', '5', false)" class="letter ">{{handleOnButtonText('t', 5)}}</button>
				    <button @click="handleOnButtonClick('y', '6', false)" class="letter ">{{handleOnButtonText('y', 6)}}</button>
				    <button @click="handleOnButtonClick('u', '7', false)" class="letter ">{{handleOnButtonText('u', 7)}}</button>
				    <button @click="handleOnButtonClick('i', '8', false)" class="letter ">{{handleOnButtonText('i', 8)}}</button>
				    <button @click="handleOnButtonClick('o', '9', false)" class="letter ">{{handleOnButtonText('o', 9)}}</button>
				    <button @click="handleOnButtonClick('p', '0', false)" class="letter ">{{handleOnButtonText('p', 0)}}</button>
				    <button @click="handleOnButtonClick('clear', 'clear', true)" class="letter letter_del">
						<icon-component iconName="backSpace" />
					</button>
			    </div>
			    <div class="row row_second">
				    <button @click="handleOnButtonClick('a', '-', false)" class="letter">{{handleOnButtonText('a', '-')}}</button>
				    <button @click="handleOnButtonClick('s', '/', false)" class="letter">{{handleOnButtonText('s', '/')}}</button>
				    <button @click="handleOnButtonClick('d', ':', false)" class="letter">{{handleOnButtonText('d', ':')}}</button>
				    <button @click="handleOnButtonClick('f', ';', false)" class="letter">{{handleOnButtonText('f', ';')}}</button>
				    <button @click="handleOnButtonClick('g', '(', false)" class="letter">{{handleOnButtonText('g', '(')}}</button>
				    <button @click="handleOnButtonClick('h', ')', false)" class="letter">{{handleOnButtonText('h', ')')}}</button>
				    <button @click="handleOnButtonClick('j', '$', false)" class="letter">{{handleOnButtonText('j', '$')}}</button>
				    <button @click="handleOnButtonClick('k', '&', false)" class="letter">{{handleOnButtonText('k', '&')}}</button>
				    <button @click="handleOnButtonClick('l', '@', false)" class="letter">{{handleOnButtonText('l', '@')}}</button>
				    <button class="letter inactive"></button>
					<button class="letter inactive letter_enter"><!--<img src="@/assets/img/entericon.png ">--></button>
			    </div>
			    <div class="row row_third">
				    <button class="letter inactive"><!--<img src="@/assets/img/arrowShiftLeft.png ">--></button>
				    <button @click="handleOnButtonClick('z', false, false)" class="letter" :class="{'inactive': type !== 'keyboard'}">{{handleOnButtonText('z', '')}}</button>
				    <button @click="handleOnButtonClick('x', false, false)" class="letter" :class="{'inactive': type !== 'keyboard'}">{{handleOnButtonText('x', '')}}</button>
				    <button @click="handleOnButtonClick('c', '.', false)" class="letter">{{handleOnButtonText('c', '.')}}</button>
				    <button @click="handleOnButtonClick('v', ',', false)" class="letter">{{handleOnButtonText('v', ',')}}</button>
				    <button @click="handleOnButtonClick('b', '?', false)" class="letter">{{handleOnButtonText('b', '?')}}</button>
				    <button @click="handleOnButtonClick('n', '!', false)" class="letter">{{handleOnButtonText('n', '!')}}</button>
				    <button @click="handleOnButtonClick('m', '\'', false)" class="letter">{{handleOnButtonText('m', '\'')}}</button>
				    <button class="letter inactive"></button>
					<button class="letter inactive"></button>
					<button class="letter inactive"></button>
				    <button class="letter inactive letter_shift"><!--<img src="@/assets/img/arrowShiftLeft.png ">--></button>
			    </div>
			    <div class="row row_fourth">
				    <!--$emit('clickSymbol')-->
				    <button @click="changeType()" class="letter ">{{type === 'keyboard' ? '&123' : 'ABC'}}</button>
				    <button class="letter inactive"></button>
				    <button class="letter inactive"><!--<img src="@/assets/img/emojiIcon.png ">--></button>
				    <button class="letter letter_space" @click="handleOnButtonClick(' ', ' ', true)"></button>
				    <button class="letter" @click="handleOnButtonClick(false, false, false, 'left')"> &lt; </button>
					<button class="letter" @click="handleOnButtonClick(false, false, false, 'right')"> > </button>
					<button class="letter inactive"></button>
			    </div>
		    </div>
	    </div>
    </div>
</template>

<script>
import Keypad from "@/components/_shared/Keypad";
import iconComponent from "@/components/_shared/Icon.vue";

export default {
	name: "Keyboard",
	components: {Keypad, iconComponent},
	emits: ['clickOnKey', 'clear', 'cursorMove'],
	data() {
		return {
			show: false,
			blurCanBeTriggered: false,
			osKeyboardVisible: false,
			viewportHeight: 0,
			viewportWidth: 0,
			visualViewportTop: 0,
			visualViewportHeight: 0,
			focusTimer: null,
			showTimer: null,
			type: 'keyboard'
		};
	},
	computed: {
		externalKeyboardStyle() {
			return this.showByDefault ? {} : {
				top: `${this.visualViewportTop}px`,
				height: `${this.visualViewportHeight}px`,
			};
		},
	},
	props: {
		hasCloseBtn: {
			type: Boolean,
			default: true,
			required: false
		},
		hasBlurAction: {
			default: false,
			required: false
		},
		showByDefault: {
			default: true,
			required: false
		},
		itemToFocus: {
			required: false
		}
	},
	created() {
		if (this.showByDefault) {
			this.show = this.showByDefault;
		}
	},
	mounted() {
		this.viewportWidth = window.innerWidth;
		this.viewportHeight = Math.max(
			window.innerHeight,
			window.visualViewport?.height || 0
		);

		window.visualViewport?.addEventListener(
			'resize',
			this.updateOsKeyboardVisibility
		);
		window.visualViewport?.addEventListener(
			'scroll',
			this.updateOsKeyboardVisibility
		);
		window.addEventListener('resize', this.updateOsKeyboardVisibility);
		document.addEventListener('focusin', this.onFocusChange);
		document.addEventListener('focusout', this.onFocusChange);
		navigator.virtualKeyboard?.addEventListener?.(
			'geometrychange',
			this.updateOsKeyboardVisibility
		);

		this.updateOsKeyboardVisibility();
	},
	beforeUnmount() {
		window.visualViewport?.removeEventListener(
			'resize',
			this.updateOsKeyboardVisibility
		);
		window.visualViewport?.removeEventListener(
			'scroll',
			this.updateOsKeyboardVisibility
		);
		window.removeEventListener('resize', this.updateOsKeyboardVisibility);
		document.removeEventListener('focusin', this.onFocusChange);
		document.removeEventListener('focusout', this.onFocusChange);
		navigator.virtualKeyboard?.removeEventListener?.(
			'geometrychange',
			this.updateOsKeyboardVisibility
		);

		clearTimeout(this.focusTimer);
		clearTimeout(this.showTimer);
	},
	methods: {
		onFocusChange() {
			clearTimeout(this.focusTimer);
			this.focusTimer = setTimeout(this.updateOsKeyboardVisibility, 0);
		},
		updateOsKeyboardVisibility() {
			const viewport = window.visualViewport;
			const height = viewport?.height || window.innerHeight;

			this.visualViewportTop = viewport?.offsetTop || 0;
			this.visualViewportHeight = height;

			const activeElement = document.activeElement;
			const editable = activeElement && (
				(
					activeElement.matches?.(
						'input:not([readonly]):not([disabled]), textarea:not([readonly]):not([disabled])'
					) &&
					!['button', 'checkbox', 'radio', 'submit', 'reset', 'file'].includes(
						activeElement.type
					)
				) ||
				activeElement.isContentEditable
			);

			if (window.innerWidth !== this.viewportWidth) {
				this.viewportWidth = window.innerWidth;
				this.viewportHeight = Math.max(window.innerHeight, height);
			}

			const nativeKeyboardHeight =
				navigator.virtualKeyboard?.boundingRect?.height || 0;
			const scaledVisualHeight = height * (viewport?.scale || 1);
			const viewportShrunk =
				window.innerHeight - scaledVisualHeight > 150 ||
				this.viewportHeight - scaledVisualHeight > 150;

			this.osKeyboardVisible =
				!!(editable || this.osKeyboardVisible) &&
				(nativeKeyboardHeight > 150 || viewportShrunk);

			if (!this.osKeyboardVisible && !editable) {
				this.viewportHeight = Math.max(
					this.viewportHeight,
					window.innerHeight,
					height
				);
			}
		},
		showKeyboard() {
			clearTimeout(this.showTimer);
			this.show = false;
			this.updateOsKeyboardVisibility();

			this.showTimer = setTimeout(() => {
				this.show = true;
				this.blurCanBeTriggered = true;
			}, 0);
		},
		changeType() {
			if (this.type === 'keyboard') {
				this.type = 'keypad';
			} else {
				this.type = 'keyboard';
			}
		},
		closeKeyboard() {
			clearTimeout(this.showTimer);
			this.show = false;
			this.blurCanBeTriggered = false;
		},
		blur() {
			if (this.hasBlurAction) {
				if (this.show && this.blurCanBeTriggered) {
					this.closeKeyboard();
				}
			}
		},
		handleOnButtonText(keyboardValue, keypadValue, both) {
			if (this.type === 'keyboard') {
				return keyboardValue
			} else {
				return keypadValue
			}
		},
		handleOnButtonClick(keyboardValue, keypadValue, both, cursorMove) {
			if (!keyboardValue && !keypadValue && !both) {
				this.$emit('cursorMove', cursorMove);
			} else {
				if (both) {
					if (keyboardValue === 'clear') {
						this.$emit('clear')
					} else {
						this.$emit('clickOnKey', keyboardValue)
					}
				} else {
					if (this.type === 'keyboard') {
						this.$emit('clickOnKey', keyboardValue)
					} else {
						if (keypadValue) {
							this.$emit('clickOnKey', keypadValue)
						}
					}
				}
			}
		}
	}
}
</script>

<style lang="less" scoped>
#keyboard {
  position: absolute;
  z-index: 1;
  width: 100%;

  &.external {
    position: fixed;
    z-index: 900;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    height: 100dvh;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 8px max(8px, env(safe-area-inset-bottom));
    pointer-events: none;

    .container {
      max-width: 100%;
      max-height: 100%;
      margin: 0 auto;
      pointer-events: auto;
    }
  }

  &.keypad-type {
    border: none;

    .container {
      width: 100%;
      padding: 0;
      border: none;
      background-color: transparent;
      box-shadow: none;

      .keypad {
        margin: 0 auto;
      }
    }
  }

  .container {
    width: 1010px;
    max-width: calc(100% - 32px);
    max-height: calc(100vh - 32px);
    max-height: calc(100dvh - 32px);
    margin: 0 auto;
    padding: 10px;
    overflow-y: auto;
    box-sizing: border-box;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 0 10px #bdbdbd;

    .cross {
      display: flex;
      justify-content: flex-end;
      cursor: pointer;

      .close {
        padding: 15px;
      }
    }

    .row {
      display: grid;
      grid-template-columns: repeat(10, minmax(0, 1fr)) minmax(0, 2fr);
      gap: clamp(2px, .6vw, 6px);
      width: 100%;
      height: auto;
      margin: 6px 0 0;

      .letter {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-width: 0;
        height: clamp(40px, 7vh, 63px);
        height: clamp(40px, 7dvh, 63px);
        padding: 0;
        border: 0;
        color: #fff;
        font-size: clamp(16px, 2.6vw, 30px);
        font-weight: normal;
        line-height: 1;
        text-align: center;

        &.inactive {
          background-color: #a3bfdc;
        }

        &:active {
          background-color: #95c7ec;
        }
      }

      &.row_third {
        grid-template-columns: repeat(12, minmax(0, 1fr));
      }

      &.row_fourth {
        grid-template-columns:
          repeat(3, minmax(0, 1fr))
          minmax(0, 6fr)
          repeat(3, minmax(0, 1fr));
      }
    }
  }
}

@media (max-width: 1100px), (max-height: 800px) {
  #keyboard.external .container {
    padding: 8px;

    .cross .close {
      padding: 8px;
    }

    .row {
      margin-top: 4px;

      .letter {
        height: clamp(34px, 5dvh, 48px);
        font-size: clamp(14px, 2vw, 22px);
      }
    }
  }
}

@media (max-height: 650px) {
  #keyboard .container .row .letter {
    height: clamp(36px, 6vh, 48px);
    height: clamp(36px, 6dvh, 48px);
  }
}
</style>